import { render, staticRenderFns } from "./ProfessionalDigitalCardForm.vue?vue&type=template&id=ca5bfc40&"
import script from "./ProfessionalDigitalCardForm.vue?vue&type=script&lang=js&"
export * from "./ProfessionalDigitalCardForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalDigitalCardForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports